<template>
  <div class="pagefav">
    <XR-edit-head titleText="我的收藏" :rightButtonShow="editButtonShow" ref="head" @editEvent="editEvent" @completeEvent="completeEvent"></XR-edit-head>
    <mu-tabs :value="activeTab" @change="handleTabChange">
      <mu-tab value="tab1" title="全部收藏"/>
      <mu-tab value="tab2" title="降价"/>
      <mu-tab value="tab3" title="失效"/>
    </mu-tabs>
    <div>
      <div class="fav-list" :style="'margin-bottom:'+ height + 'px'">
        <div class="fav-item" v-for="favItem in favList" :key="favItem.SkuId">
          <div class="item-check">
            <mu-checkbox class="fav-checkbox" :nativeValue="favItem.SkuId.toString()" v-model="checkList" iconClass="chkbox" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes" slot="left" v-if="mode=='edit'" />
          </div>
          <router-link :to="'/retail/productDetail?skuId='+favItem.SkuId"><div class="pro-img"><img :src="favItem.ImgPath?favItem.ImgPath:IMGServer_URL+'/images/index-item-default.png'" /></div></router-link>
          <div class="pro-info" :style="{width:proNameWidth+'px'}">
            <router-link :to="'/retail/productDetail?skuId='+favItem.SkuId"><p class="pro-name">{{favItem.Name}}</p></router-link>
            <p class="pro-price"><i class="fa fa-rmb"></i>{{favItem.SalePrice.toFixed(2)}}</p>
            <p class="pro-jiangjia" v-if="favItem.FavoritePrice-favItem.SalePrice>0">
              <i class="fa fa-arrow-down jiangjia-icon"></i>
              <span>已降价{{(favItem.FavoritePrice-favItem.SalePrice).toFixed(2)}}元</span>
            </p>
            <p class="pro-jiangjia" v-else-if="favItem.State==1">
              <i class="fa fa-warning"></i>
              <span>已失效</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-bar" v-if="mode =='edit'">
      <div class="chk-button">
        <mu-checkbox @change="checkAll()" label="全选" v-model="checkAllState" class="chkbox" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
      </div>
      <div class="operator-button">
        <mu-flat-button label="取消关注" primary  backgroundColor="red" color="white" @click="cancelFav" fullWidth />
      </div>
    </div>
    <mu-dialog :open="dialog" title="确定要删除吗" @close="close">      
      <mu-flat-button slot="actions" @click="close" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="close" label="确定"/>
    </mu-dialog>
    <XR-toast @onClose="getFavPage(true)" ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loaded: true,
      proNameWidth:(parseInt(document.documentElement.clientWidth)-160),
      dialog: false,
      activeTab: 'tab1',
      searchInfo:{
        searchType: '',
        pageIndex: 0
      },
      pageEnd:0,
      num:15,
      favList:[],
      skuList:[],
      checkList:[],
      checkAllState:false,
      scrollDone:function(){},
	  mode: this.$route.query.mode?this.$route.query.mode:'normal', //如果mode=normal，则代表正常，如果mode=select，则代表选择模式，选中即跳转回去
	  editButtonShow: true,
	  height:0
    }
  },
  mounted(){
    var cacheTab = this.readTabCache()
    this.activeTab = cacheTab
    this.handleTabChange(cacheTab)
  },
  methods: {
    listLength(){
      if(this.favItem.length==0){
        this.$refs.XRPageTip.ShowEmpty('暂无数据')
      }
    },
    handleTabChange (val) {
      this.activeTab = val
      this.addTabCache(val)
      if(this.activeTab == "tab1"){
        this.searchInfo.searchType = "0"
      }
      else if(this.activeTab == "tab2"){
        this.searchInfo.searchType = "1"
      }
      else if(this.activeTab == "tab3"){
        this.searchInfo.searchType = "2"
      }
      this.getFavPage(true)

    },
    handleActive () {
      
    },
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    checkAll(){
      if(!this.checkAllState){        
        this.checkList = this.skuList
        
      }else{
        this.checkList = []
      }
    },
	editEvent: function(){
      this.mode='edit';
	  this.height=56;
    },
    completeEvent: function(){
	  this.mode='normal';
	  this.height=0;
    },
    getFavPage(isNewSearch){
      var ths = this; 
           
      ths.$post(
        "/Shop/RetailServer/GetFavoritePage",
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        if(!res.IsSuccess){               
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")           
          }
          if(isNewSearch){
            ths.favList = []                   
          }        
        }else{                    
          ths.$refs.XRtoast.hide()
          if(isNewSearch){         
            ths.favList = res.Data.List;                         
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){                         
              ths.favList.push(res.Data.List[i])
            }
          }
          ths.skuList = []
          for(var j = 0; j< ths.favList.length;j++){            
            ths.skuList.push(ths.favList[j].SkuId.toString())
          }
          if(ths.favList.length==0){
            ths.$refs.XRPageTip.ShowEmpty('暂无数据')
          }else{            
            ths.$refs.XRPageTip.initTip()  
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
          ths.loaded= false
        }
      });
    },    
    cancelFav(){
      var ths = this;    
      ths.$post(
        "/Shop/RetailServer/CancelFavoriteBatch",
        JSON.stringify({skuIds:this.checkList})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }
        else{          
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.getOrderList(false);     
    },
    addTabCache(type){
      window.localStorage.UCFavProductTab = type
    },
    readTabCache(){
      var tab = window.localStorage.UCFavProductTab
      if(!tab){
        tab = 'tab1'
      }
      return tab
    }
  }
}
</script>
<style>
#app .pagefav{
  background: #fff;
}
.pagefav .fav-list{
  overflow: hidden;
  background: white;
}
.pagefav .fav-item{
  overflow: hidden;
  border-bottom: 1px solid #eee;
  padding:10px 0;
  display: flex;
  align-items: center;
}
.pagefav .item-check{
  float: left;
  width: 40px;
  text-align: center;
}
.pagefav .item-check .mu-checkbox-icon-uncheck{
  color:#999;
}
.pagefav .pro-img{
  float: left;
  padding: 10px;
  width: 80px;
  height: 80px;
}
.pagefav .pro-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.pagefav .pro-info{
  float: left;
  padding: 10px 10px;
}
.pagefav .pro-info .pro-name{
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  color:#666;
}
.pagefav .pro-info .pro-price{
  height: 32px;
  line-height: 32px;
  margin-top: 10px;
  font-size: 22px;
  color:red;
}
.pagefav .pro-info .pro-price .fa{
  font-size: 14px;
}
.pagefav .pro-info .pro-jiangjia{
  height: 16px;
  line-height: 16px;
  color:red;
  margin-top: 10px;
  font-size: 12px;
}
.pagefav .pro-info .jiangjia-icon{
  height: 16px;
  line-height: 16px;
  color:white;
  background: red;
  font-size: 12px;
  width: 16px;
  text-align: center;
  padding: 0;
}

.pagefav .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  border-top:1px solid #eee;
  background:#fff;
}
.pagefav .bottom-bar .mu-checkbox-icon-uncheck{
  color:#999;
}
.pagefav .chk-button{
  float: left;
  margin-top: 14px;
  margin-left: 10px;
  font-size: 14px;
}
.pagefav .operator-button{
  float: right;
  line-height: 56px;
}
.pagefav .bottom-bar .mu-flat-button{
  height: 56px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/fav.vue